<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">CONTENTS</p>
<p class="toc"><a href="#/Foreword">Foreword, by Daniel Boulud</a></p>
<p class="toc"><a href="#/Acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/Introduction">Introduction</a></p>
<p class="toc1"><a href="#/Chapter1#C1">Poland</a></p>
<p class="toc"><span href="#/Chapter2#C2" title="Link target outside of Sample">Germany and Austria</span></p>
<p class="toc"><span href="#/Chapter3#C3" title="Link target outside of Sample">Belgium and France</span></p>
<p class="toc"><span href="#/Chapter4#C4" title="Link target outside of Sample">Hungary and Czechoslovakia</span></p>
<p class="toc"><span href="#/Chapter5#C5" title="Link target outside of Sample">Romania, Russia and the Ukraine</span></p>
<p class="toc"><span href="#/Chapter6#C6" title="Link target outside of Sample">Greece</span></p>
<p class="toc1"><span href="#/Glossary" title="Link target outside of Sample">Glossary</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?1839f204